(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["studio-locator"]) return;
  try {
    
  (function() {
    // --- Google Sheet config (geen Apps Script meer nodig) ---
    var SHEET_ID = '1-wJyAvrZDEnahgH2twoa4XBMTPXBhp6_bcmnhKZIq5k';
    var GID = '190334087';
    var jsonUrl = 'https://docs.google.com/spreadsheets/d/' + SHEET_ID + '/gviz/tq?tqx=out:json&headers=1&gid=' + GID;

    var leafletCSS = 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/leaflet.min.css';
    var leafletJS = 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/leaflet.min.js';

    var link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = leafletCSS;
    document.head.appendChild(link);

    var script = document.createElement('script');
    script.src = leafletJS;
    script.onload = initMap;
    document.head.appendChild(script);

    var allStudios = [];
    var currentFilter = 'all';
    var map, markers = [];

    function initMap() {
      map = L.map('studio-map').setView([52.1326, 5.2913], 6);
      L.tileLayer('https://{s}.basemaps.cartocdn.com/light_nolabels/{z}/{x}/{y}{r}.png?key=cb1_3ta9_1_a34fa582321c8606b30ae885', {
        attribution: '',
        maxZoom: 19
      }).addTo(map);
      fetchStudios();
      setupFilters();
    }

    function fetchStudios() {
      fetch(jsonUrl)
        .then(function(res) { return res.text(); })
        .then(function(text) {
          // gviz wrapt de JSON in /*O_o*/ google.visualization.Query.setResponse({...});
          var start = text.indexOf('{');
          var end = text.lastIndexOf('}');
          var json = JSON.parse(text.substring(start, end + 1));

          var cols = json.table.cols.map(function(c) {
            return (c.label || '').toString().trim().toLowerCase();
          });

          function colIndex() {
            for (var i = 0; i < arguments.length; i++) {
              var idx = cols.indexOf(arguments[i]);
              if (idx !== -1) return idx;
            }
            return -1;
          }

          var iName = colIndex('store name', 'name', 'studio', 'naam');
          var iAddress = colIndex('address', 'adres');
          var iRegion = colIndex('region', 'city', 'stad', 'regio');
          var iCountry = colIndex('country', 'land');
          var iMobile = colIndex('mobile', 'phone', 'telefoon', 'tel');
          var iEmail = colIndex('email', 'e-mail');
          var iCoords = colIndex('coordinates', 'coords', 'coordinaten', 'latlng');
          var iLat = colIndex('latitude', 'lat');
          var iLng = colIndex('longitude', 'lng', 'lon', 'long');

          function cellVal(row, idx) {
            return (idx !== -1 && row.c[idx] && row.c[idx].v != null) ? row.c[idx].v : '';
          }

          allStudios = json.table.rows.map(function(row) {
            var lat = '', lng = '';
            if (iLat !== -1 && iLng !== -1) {
              lat = cellVal(row, iLat);
              lng = cellVal(row, iLng);
            } else if (iCoords !== -1) {
              var parts = String(cellVal(row, iCoords)).split(/[,;]/);
              lat = (parts[0] || '').trim();
              lng = (parts[1] || '').trim();
            }
            return {
              name: String(cellVal(row, iName)),
              address: String(cellVal(row, iAddress)),
              region: String(cellVal(row, iRegion)),
              country: String(cellVal(row, iCountry)),
              mobile: String(cellVal(row, iMobile)),
              email: String(cellVal(row, iEmail)),
              latitude: lat,
              longitude: lng
            };
          }).filter(function(s) { return s.name; });

          allStudios.sort(function(a, b) { return a.name.localeCompare(b.name); });
          console.log('Studios geladen:', allStudios.length, allStudios);
          renderStudios();
          renderMarkers();
        })
        .catch(function(err) {
          console.error('Error fetching studios:', err);
          document.getElementById('studio-cards').innerHTML =
            '<p class="studio-empty" style="color:#c0392b;">Kon studio\'s niet laden. Zet de Google Sheet op \u201cIedereen met de link kan bekijken\u201d.</p>';
        });
    }

    function normCountry(c) {
      var v = String(c).trim().toLowerCase();
      if (v === 'nl' || v.indexOf('nether') !== -1 || v.indexOf('nederland') !== -1) return 'NL';
      if (v === 'be' || v.indexOf('belg') !== -1) return 'BE';
      return v.toUpperCase();
    }

    function setupFilters() {
      var btns = document.querySelectorAll('.filter-btn');
      btns.forEach(function(btn) {
        btn.addEventListener('click', function() {
          btns.forEach(function(b) { b.classList.remove('active'); });
          btn.classList.add('active');
          currentFilter = btn.dataset.filter;
          renderStudios();
          renderMarkers();
        });
      });
    }

    function getFilteredStudios() {
      if (currentFilter === 'all') {
        return allStudios.filter(function(s) {
          var n = normCountry(s.country);
          return n === 'NL' || n === 'BE';
        });
      }
      return allStudios.filter(function(s) {
        return normCountry(s.country) === currentFilter;
      });
    }

    function renderStudios() {
      var container = document.getElementById('studio-cards');
      var filtered = getFilteredStudios();

      if (filtered.length === 0) {
        container.innerHTML = '<p class="studio-empty">Geen studio\'s gevonden voor deze selectie.</p>';
        return;
      }

      container.innerHTML = filtered.map(function(studio) {
        var phone = studio.mobile
          ? '<p><a href="tel:' + studio.mobile + '">\uD83D\uDCDE ' + studio.mobile + '</a></p>' : '';
        var mail = studio.email
          ? '<p><a href="mailto:' + studio.email + '">\u2709\uFE0F ' + studio.email + '</a></p>' : '';
        var region = studio.region ? '<p>' + studio.region + '</p>' : '';
        return '<div class="studio-card" data-studio-id="' + studio.name + '">' +
          '<h3>' + studio.name + '</h3>' +
          '<p>' + studio.address + '</p>' +
          region + phone + mail +
          '</div>';
      }).join('');

      document.querySelectorAll('.studio-card').forEach(function(card) {
        card.addEventListener('click', function() {
          highlightStudio(card.dataset.studioId);
        });
      });
    }

    function renderMarkers() {
      markers.forEach(function(m) { map.removeLayer(m); });
      markers = [];

      var filtered = getFilteredStudios();

      filtered.forEach(function(studio) {
        var lat = parseFloat(studio.latitude);
        var lng = parseFloat(studio.longitude);
        if (!isNaN(lat) && !isNaN(lng)) {
          var marker = L.circleMarker([lat, lng], {
            radius: 12,
            fillColor: '#000',
            color: '#fff',
            weight: 3,
            opacity: 1,
            fillOpacity: 0.8
          }).addTo(map);

          marker.bindPopup('<strong>' + studio.name + '</strong><br>' + studio.address);
          marker.studioName = studio.name;
          marker.on('click', function() { highlightStudio(studio.name); });
          markers.push(marker);
        }
      });

      if (markers.length > 0) {
        var group = new L.featureGroup(markers);
        map.fitBounds(group.getBounds().pad(0.1));
      }
    }

    function highlightStudio(studioName) {
      document.querySelectorAll('.studio-card').forEach(function(card) {
        card.classList.remove('active');
        if (card.dataset.studioId === studioName) {
          card.classList.add('active');
          card.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
      });
      markers.forEach(function(marker) {
        if (marker.studioName === studioName) {
          marker.openPopup();
        }
      });
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
